import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  reservation: "",
  isFormValid: false,
  milesData: "",
};

/******************* 
@purpose : vehicle booking Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function booking(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_RESERVATION_DETAILS:
      return Object.assign({}, ini_data, {
        reservation: action.data,
      });

    case types.SET_IS_FORM_VALID:
      return Object.assign({}, ini_data, {
        isFormValid: action.data,
      });

    case types.SET_DISTANCE_MILES_DETAILS:
      return Object.assign({}, ini_data, {
        milesData: action.data,
      });

    default:
      return ini_data;
  }
}
